import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { EMPLOYEE_BLUE, WHITE, PINK_RED } from "../colors";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import Autocomplete from "@mui/material/Autocomplete";
import HeightBox from "./HeightBox";
import CustomerService from "../services/customerService";
import EmployeeProfileImage from "./uploads/EmployeeProfileImage";
import MediaService from "../services/mediadocService";
import { IconButton, MenuItem, Select } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  AFFIDAVIT,
  AGREEMENT,
  COMPLAIN,
  IMMIGRATION_LETTER,
  PASSPORT_COPY_ONE,
  PASSPORT_COPY_TWO,
  POLICE,
  REGISTRATION,
  TICKET,
  VISA,
} from "../constants/mediaType";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers } from "../actions/customers";

const style = {
  position: "absolute",
  top: "50%",
  left: "60%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  p: 4,
};

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 430,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 180,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  color: WHITE,
}));

const CustomPaper = styled(Paper)(({ theme }) => ({
  height: 150,
  minWidth: 435,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: WHITE,
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

export default function AddFormDocumentModel(props) {
  console.log(props)
  const { okFunction, openModel, handleCancelModel, cancelFunction } = props;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = React.useState({
    customer: props.userId,
    filePath: "",
    mediaType: REGISTRATION,
    description: "",
    tmeCreated: new Date(),
  });
  const [allPrevForms, setAllPrevForms] = useState([]);
  const [prevFormsLoading, setPrevFormsLoading] = useState(false);
  // After the api call setLoading should be make to false
  useEffect(() => {
    const getPageInfo = async () => {
      setPrevFormsLoading(true);
      const types = await MediaService.getAllMediaOfTypesOfCustomer(props.userId);
      setAllPrevForms(types.data);
      setPrevFormsLoading(false);
    };

    return props.userId && getPageInfo();
  }, [props.userId]);

  const handleChange = (event) => {
    console.log(props)
    setFormData({
      ...formData,
      mediaType: event.target.value,
    });
  };

  const selectFileToUpload = (file) => {
    if (file) {
      setFormData({
        ...formData,
        filePath: file,
      });
    }
  };
  const createMediaDoc = async () => {
    setLoading(true);
    var bodyFormData = new FormData();
    bodyFormData.set("customer", props.userId);
    bodyFormData.set("filePath", formData.filePath);
    bodyFormData.set("description", formData.description);
    bodyFormData.set("tmeCreated", formData.tmeCreated);
    bodyFormData.set("mediaType", formData.mediaType);

    let res;
    if (allPrevForms.includes(formData.mediaType)) {
      res = await MediaService.updateMedia(bodyFormData);
    } else {
      res = await MediaService.createMedia(bodyFormData);
    }

    setFormData({
      customer: props.userId,
      filePath: "",
      description: "",
      tmeCreated: new Date(),
    });

    if (res.status === 200 || res.status === 201) {
      setLoading(false);
      const message = "Media created successfully";

      alert(message);
    } else {
      setLoading(false);

      alert("Media creation failed");
    }

    cancelFunction();
  };
  return (
    <Modal
      open={openModel}
      onClose={handleCancelModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h4">
          Media / Document Submission Form {props.userId}
        </Typography>

        <HeightBox height={4} />

        <HeightBox height={10} />

        {/* <Typography color="#000">Media type</Typography> */}
        <CustomSelect
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          onChange={handleChange}
          defaultValue={REGISTRATION}
        >
          <MenuItem value={REGISTRATION}>Registration Form</MenuItem>
          <MenuItem value={PASSPORT_COPY_ONE}>Passport copy one</MenuItem>
          <MenuItem value={PASSPORT_COPY_TWO}>Passport copy two</MenuItem>
          <MenuItem value={POLICE}>Police report</MenuItem>
          <MenuItem value={AFFIDAVIT}>Affidavit as letter</MenuItem>
          <MenuItem value={IMMIGRATION_LETTER}>Immigration letter</MenuItem>
          <MenuItem value={VISA}>Visa</MenuItem>
          <MenuItem value={AGREEMENT}>Agreement</MenuItem>
          <MenuItem value={TICKET}>Ticket</MenuItem>
          <MenuItem value={COMPLAIN}>Complain</MenuItem>
        </CustomSelect>

        {/* </Stack> */}
        <HeightBox height={20} />
        <CustomPaper elevation={0}>
          {/* <Typography color="#000">Upload File Here</Typography> */}
          <EmployeeProfileImage offImage={true} fileUploadHandler={selectFileToUpload} />
        </CustomPaper>
        <HeightBox height={20} />
        <CustomTextField
          multiline
          rows={4}
          placeholder="Type the description here"
          onChange={(event) => {
            setFormData({
              ...formData,
              description: event.target.value,
            });
          }}
          value={formData.description}
        />
        <HeightBox height={20} />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            renderInput={(props) => <CustomTextField placeholder="Date and Time" {...props} />}
            onChange={(e) => {
              setFormData({
                ...formData,
                timeCreated: e.target.value,
              });
            }}
            value={formData.tmeCreated}
          />
        </LocalizationProvider>
        <HeightBox height={20} />
        <Stack direction="row" alignItems="center" spacing={3}>
          {prevFormsLoading && <CircularProgress size={15} />}
          {!prevFormsLoading && (
            <>
              <CustomButton
                style={{ backgroundColor: PINK_RED }}
                onClick={() => {
                  cancelFunction();
                }}
              >
                Cancel
              </CustomButton>
              {allPrevForms.includes(formData.mediaType) && (
                <CustomButton
                  style={{ backgroundColor: EMPLOYEE_BLUE }}
                  disabled={loading || formData.description === ""}
                  onClick={() => {
                    createMediaDoc();
                  }}
                >
                  {loading ? <CircularProgress size={15} /> : "Replace"}
                </CustomButton>
              )}
              {!allPrevForms.includes(formData.mediaType) && (
                <CustomButton
                  style={{ backgroundColor: EMPLOYEE_BLUE }}
                  disabled={loading || formData.description === ""}
                  onClick={() => {
                    createMediaDoc();
                  }}
                >
                  {loading ? <CircularProgress size={15} /> : "Submit"}
                </CustomButton>
              )}
            </>
          )}
        </Stack>
      </Box>
    </Modal>
  );
}
